export default class TitleText {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {}
}
